export const validationStatusSagaActionTypes = {
  callGetValidationStatusListSaga: "callGetValidationStatusListSaga",
  callGetValidationPredefinedDataSaga: "callGetValidationPredefinedDataSaga",
  callAddValidationStatusSaga: "callAddValidationStatusSaga",
  callUpdateValidationStatusSaga: "callUpdateValidationStatusSaga",
  callDeleteValidationStatusSaga: "callDeleteValidationStatusSaga",
};

export type ValidationStatusUpsertPayload = {
  partner_name?: string;
  technology: string;
  integration: string;
  validation_status: 0 | 1;
};

export const getValidationStatusListSagaAction = () => ({
  type: validationStatusSagaActionTypes.callGetValidationStatusListSaga,
});

export const getValidationPredefinedDataSagaAction = () => ({
  type: validationStatusSagaActionTypes.callGetValidationPredefinedDataSaga,
});

export const addValidationStatusSagaAction = (payload: {
  body: ValidationStatusUpsertPayload;
  onSuccess?: () => void;
  onError?: (message: string) => void;
}) => ({
  type: validationStatusSagaActionTypes.callAddValidationStatusSaga,
  payload,
});

export const updateValidationStatusSagaAction = (payload: {
  ID: number;
  body: ValidationStatusUpsertPayload;
  onSuccess?: () => void;
  onError?: (message: string) => void;
}) => ({
  type: validationStatusSagaActionTypes.callUpdateValidationStatusSaga,
  payload,
});

export const deleteValidationStatusSagaAction = (payload: {
  ID: number;
  onSuccess?: () => void;
  onError?: (message: string) => void;
}) => ({
  type: validationStatusSagaActionTypes.callDeleteValidationStatusSaga,
  payload,
});

